import { withInstall } from "@bvite/utils/with-install";

import Alert from "./src/alert.vue";

export const VfAlert = withInstall(Alert);

export default VfAlert;

export * from "./src/alert";
